





















// vendor
import { defineComponent, PropType, computed, ref } from "@vue/composition-api";
// local
import { FormItem, MultipleChoice, DataChannel } from "../../ts/types";
import ErrorOverlay from "./error-overlay.vue";
import ErrorBox from "./error-box.vue";

export default defineComponent({

	emits:[ "input" ],
	props:{
		value:{
			type:Number
		},
		config:{
			type:Object as PropType<FormItem<MultipleChoice>>,
			required:true
		}
	},
	components:{
		ErrorOverlay,
		ErrorBox
	},
	setup(props, context){

		const pristine = ref(true);

		const val = computed({
			get:() => props.value,
			set:v => context.emit("input", v)
		});

		const state = computed(() => {
			if(val.value === undefined){ return false; }
			if(val.value < 0){ return false; }
			return true;
		});

		const isValid = () => {
			pristine.value = false;
			return state.value;
		};

		const getChannels = (prefix:string):DataChannel<number>[] => {
			const v = val.value;
			return v !== undefined ? [
				{
					key: prefix,
					data:v
				}
			] : [];
		};

		const displayOptions = computed(() => {
			let options = props.config.settings.options;
			return options.map((o, i) => {
				return {
					text:o,
					value:i
				}
			})
		});

		const init = () => {
			if(val.value === undefined){ val.value = -1; }
		};

		init();

		return {
			pristine,
			state,
			val,
			displayOptions,
			isValid,
			getChannels
		};
	}
});

